import { createFeatureSelector, createSelector, createReducer, on, Action } from '@ngrx/store';
import * as fromActions from '../actions/ec2.actions';
import { Ec2sState } from './clacmycloud.states';

export const initialState: Ec2sState = { ec2s: []};

export const ec2Reducer = createReducer(
    initialState
  );

  export const getEc2State = createFeatureSelector<Ec2sState>('Ec2sState');
  export const getArticles = createSelector(
    getEc2State, 
    (state: Ec2sState) => state.ec2s 
); 